module.exports = __webpack_public_path__ + "img/icon-differentials_12.c6b4fbe2.svg";